import { Grid } from '@progress/kendo-react-grid';
import { RefObject } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import { BlindReceivePermissions } from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';
import { ILineItemSummariesResponse } from 'src/services/useLineItemSummariesApi';

const useLineItemSummariesColumns: (
  tableRef: RefObject<Grid>
) => GridColumn<ILineItemSummariesResponse>[] = () => {
  const isBlindReceive = usePermission({ permissions: BlindReceivePermissions });

  const lineItemSummariesColumns: GridColumn<any>[] = [
    {
      field: 'allItemsInvoiced',
      title: 'All Items Invoiced',
      width: '120px',
      dataType: 'fixed',
      menu: false,
    },
    ...(isBlindReceive
      ? []
      : ([
          {
            field: 'poQty',
            title: 'Total PO Qty',
            width: '120px',
            dataType: 'number',
            menu: false,
          },
        ] as GridColumn<any>[])),
    {
      field: 'invoicedQty',
      title: 'Total Doc Qty',
      width: '120px',
      dataType: 'number',
      menu: false,
    },
    {
      field: 'invoicedPercent',
      title: '% Invoiced',
      width: '120px',
      format: '{0:n2}%',
      dataType: 'number',
      menu: false,
    },
    {
      field: 'itemNum',
      title: 'Item #',
      width: '120px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'description',
      title: 'Description',
      width: '150px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'uom',
      title: 'UOM',
      width: '100px',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'price',
      title: 'Price',
      width: '100px',
      format: '{0:c}',
      dataType: 'dollar',
      menu: false,
    },
    {
      field: 'subTotal',
      title: 'Subtotal',
      width: '100px',
      format: '{0:c}',
      dataType: 'dollar',
      menu: false,
    },
  ];
  return lineItemSummariesColumns;
};

export default useLineItemSummariesColumns;
